export const fieldList = [
  {
    label: '评价编码',
    type: 'input',
    value: 'evaluationCode'
  },
  {
    label: '产品质量评价办法',
    type: 'input',
    value: 'evaluateMethodName'
  },
  {
    label: '创建日期',
    type: 'date',
    value: 'createTime',
    defaultTime: ['00:00:00', '23:59:59'],
    valueFormat: 'yyyy-MM-dd HH:mm:ss',
    dateType: 'daterange'
  },
  {
    label: '发布日期',
    type: 'date',
    value: 'publishTime',
    defaultTime: ['00:00:00', '23:59:59'],
    valueFormat: 'yyyy-MM-dd HH:mm:ss',
    dateType: 'daterange'
  },
  {
    label: '状态',
    type: 'select',
    value: 'codeStatus',
    list: 'codeStatusList'
  },
  {
    label: '专业',
    type: 'input',
    value: 'specialtyName'
  },
  {
    label: '产品名称',
    type: 'input',
    value: 'productName'
  },
  {
    label: '适用范围',
    type: 'select',
    value: 'supplierType',
    list: 'supplierTypeList'
  }
];

export const listTypeInfo = {
  width: {
    labelWidth: 140,
    itemWidth: 200
  },
  // 状态: 100:保存，101：待完善，102：审核中，103：审核拒绝，104：已发布
  // 102：审核中，103：审核拒绝，104：已发布的评价办法才能查看
  codeStatusList: [
    { name: '全部', id: '' },
    // { name: '保存', id: 100 },
    { name: '待完善', id: 101 },
    { name: '审核中', id: 102 },
    { name: '审核拒绝', id: 103 },
    { name: '已发布', id: 104 }
  ],
  supplierTypeList: [
    { name: '全部', id: '' },
    { name: '生产商', id: 101 },
    { name: '代理商', id: 102 },
    { name: '流通商', id: 103 }
  ]
};

export const tableLabel = [
  {
    label: '评价编码',
    param: 'evaluationCode',
    align: 'center',
    minWidth: 140
  },
  {
    label: '适用范围',
    param: 'supplierType',
    align: 'center',
    minWidth: 140,
    slot: 'supplierType'
  },
  {
    label: '产品质量评价办法',
    param: 'evaluateMethodName',
    align: 'center',
    minWidth: 180
  },
  {
    label: '专业',
    param: 'specialtyName',
    align: 'center',
    minWidth: 110
  },
  {
    label: '创建日期',
    param: 'createTime',
    align: 'center',
    minWidth: 180
  },
  {
    label: '产品名称',
    align: 'center',
    minWidth: 110,
    slot: 'productNameList'
  },
  {
    label: '发布日期',
    param: 'publishTime',
    align: 'center',
    minWidth: 180
  },
  {
    label: '状态',
    param: 'codeStatus',
    align: 'center',
    minWidth: 110,
    slot: 'codeStatus'
  },
  {
    label: '是否删除',
    param: 'delStatus',
    align: 'center',
    minWidth: 110,
    render(row) {
      return row.delStatus === 0 ? '未删除' : '已删除';
    }
    // slot: 'delStatus',
  },
  {
    label: '操作',
    align: 'center',
    fixed: 'right',
    width: '140',
    slot: 'handle',
    minWidth: 100
  }
];

export const oArrayToTree = arr => {
  let result = [];
  if (!Array.isArray(arr) || arr.length === 0) {
    return result;
  }
  let map = {};
  arr.forEach(item => (map[item.nodeId] = item));
  arr.forEach(item => {
    //
    const parent = map[item.parentNodeId];
    if (parent) {
      // (parent.children || (parent.children=[])).push(item);
      if (parent.children) {
        parent.children.push(item);
      } else {
        // 如果 parent 没有 children 属性(顶级) 则赋值为 []
        parent.children = [];
        // 然后push item
        parent.children.push(item);
      }
    } else {
      result.push(item);
    }
  });
  return result;
};
